var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePropertyMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1423"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#494C54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#333742",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0006 9C15.6426 9 13.7256 10.917 13.7256 13.275C13.7256 15.588 15.5346 17.46 17.8926 17.541C17.9646 17.532 18.0366 17.532 18.0906 17.541C18.1086 17.541 18.1176 17.541 18.1356 17.541C18.1446 17.541 18.1446 17.541 18.1536 17.541C20.4576 17.46 22.2666 15.588 22.2756 13.275C22.2756 10.917 20.3586 9 18.0006 9Z",
    fill: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5721 19.9352C20.0611 18.2612 15.9661 18.2612 13.4371 19.9352C12.2941 20.7002 11.6641 21.7352 11.6641 22.8422C11.6641 23.9492 12.2941 24.9752 13.4281 25.7312C14.6881 26.5772 16.3441 27.0002 18.0001 27.0002C19.6561 27.0002 21.3121 26.5772 22.5721 25.7312C23.7061 24.9662 24.3361 23.9402 24.3361 22.8242C24.3271 21.7172 23.7061 20.6912 22.5721 19.9352Z",
    fill: "#E0E1E2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePropertyMemory);
export default __webpack_public_path__ + "static/media/ProfilePropertyMemory.56a4f0bd7d1bb7d70ac27fea3c8a0e63.svg";
export { ForwardRef as ReactComponent };